// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"71":"cb525ef8","150":"dd111a5e","545":"00c2757f","551":"703e96ec","605":"940369fc","662":"30a4ed69"}[chunkId] + ".chunk.js";
};